import React from 'react';

const fields = {
  RCA: [['ruoloAssistito', 'Ruolo dell’assistito nel sinistro']],
  Conducente: [['ruoloAssistito', 'Ruolo dell’assistito'], ['veicoloAssistito', 'Veicolo condotto']],
  Trasportato: [['posizioneVeicolo', 'Posizione nel veicolo'], ['veicoloAssistito', 'Veicolo su cui viaggiava']],
  Pedone: [['attraversamento', 'Luogo e modalità dell’attraversamento']],
  Bici: [['tipoBicicletta', 'Tipo di bicicletta'], ['ruoloAssistito', 'Ruolo dell’assistito']],
  Auto: [['veicoloAssistito', 'Veicolo danneggiato']],
  'Infortunio sul lavoro': [['datoreLavoro', 'Datore di lavoro'], ['mansione', 'Mansione'], ['luogoLavoro', 'Luogo di lavoro']],
  'RC diversi': [['tipoDanno', 'Tipo di danno']],
  'Rivalsa Ditta': [['datoreLavoro', 'Ditta'], ['soggettoRivalsa', 'Soggetto verso cui si esercita la rivalsa']],
  'RC professionale': [['professioneAssicurato', 'Professione dell’assicurato'], ['descrizioneContestazione', 'Contestazione']],
  'Polizza infortuni': [['numeroPolizza', 'Numero di polizza'], ['garanzia', 'Garanzia interessata']]
};

export default function DettagliTipoPratica({ tipo, data, setData }) {
  const selected = fields[tipo] || [];
  return <section>
    <h2>Dati specifici: {tipo}</h2>
    <p>Campi CISA per descrivere questa tipologia di pratica. Compila solo quelli pertinenti.</p>
    {selected.map(([key, label]) => <div key={key} style={{ marginBottom: 12 }}>
      <label>{label}<br /><input style={{ width: 'min(100%, 600px)' }} maxLength={500} value={data[key] || ''}
        onChange={event => setData(previous => ({ ...previous, [key]: event.target.value }))} /></label>
    </div>)}
  </section>;
}
